enum ArticleSubscriptionTypeEnum {
  ONLINE_OPEN = 'Online Open',
  OPEN_ACCESS = 'Open Access',
}

export default ArticleSubscriptionTypeEnum;
